<template>
  <div class="tablet:tw-px-16 apDesktop:tw-px-20 tablet:tw-pb-20 tw-px-6 tw-overflow-y-auto scrollbar-hide">
    <p class="services-tag animate__animated animate__fadeInUp tw-self-stretch apDesktop:tw-text-body-bold-mobile tw-text-label-bold-mobile tw-uppercase dark:tw-text-white tw-text-ap-nero tw-mb-4">
      OUR SERVICES
    </p>
    <p class="services-title animate__fadeInUp animate__animated tw-w-full md:tw-w-[90%] lg:tw-w-[800px] apDesktop:tw-text-h2-bold-desktop tw-text-h2-bold-mobile tw-font-semibold dark:tw-text-white tw-text-ap-nero  tw-mb-8 md:tw-mb-12">
      {{ tagline }}
    </p>
    <div class="services-description animate__fadeIn animate__animated content apDesktop:tw-text-body-desktop tw-text-body-mobile dark:tw-text-white tw-text-ap-nero tw-mb-8 md:tw-mb-12" v-html="description" />
  </div>
</template>

<script setup lang="ts">

import { onMounted, onBeforeUnmount } from 'vue';

const props = defineProps<{
  text: string
  tagline: string
  description: string
  slug: string
}>()

onMounted(() => {
  window.history.pushState({}, '', '/services/' + props.slug);
})

onBeforeUnmount(() => {
  window.history.replaceState({}, '', '/');
})

</script>

<style scoped>
.content :deep(ul) {
  list-style-type: '✦';
  margin-left: 1rem;
}

.content :deep(ul li) {
  padding-left: 10px;
}

.content:deep(ul ul) {
  list-style-type: "- ";
  margin-left: 1.5rem;
}

.services-tag {
  animation-delay: 300ms !important;
}

.services-title {
  animation-delay: 400ms !important;
}

.services-description {
  animation-delay: 500ms !important;
  animation-duration: 500ms !important;
}

.services-tag, .services-title {
  animation-duration: 300ms !important;
}

</style>